export enum FeatureCooldownType {
  LifeRequest = 'lifeRequest',
}
